import React from 'react';
import { MemoryRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAppLanguage } from '@/core/hooks/useAppLanguage';

import { MenuPage } from '@/features/menu/pages/MenuPage';

interface MenuAppProps {
  itemIds?: string[];
  disabledItemIds?: string[];
  accountId?: string;
  accountName?: string;
  profileImage?: string;
  searchOptions?: Array<string | { label?: string; name?: string; universeId?: string; id?: string; value?: string }>;
  selectedSearch?: string;
  universeId?: string;
  initialEntries?: string[];
}

export const MenuApp: React.FC<MenuAppProps> = ({
  itemIds,
  disabledItemIds,
  accountId,
  accountName,
  profileImage,
  searchOptions,
  selectedSearch,
  universeId,
  initialEntries,
}) => {
  useAppLanguage();

  return (
    <MemoryRouter initialEntries={initialEntries}>
      <Routes>
        <Route
          path="/"
          element={
            <MenuPage
              itemIds={itemIds}
              disabledItemIds={disabledItemIds}
              accountId={accountId}
              accountName={accountName}
              profileImage={profileImage}
              searchOptions={searchOptions}
              selectedSearch={selectedSearch}
              universeId={universeId}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MemoryRouter>
  );
};
